"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }// A constraint that has to accept any async signature; `unknown[]` params
// would reject callers whose functions take specific argument types.
// oxlint-disable-next-line typescript/no-explicit-any










function asyncDebounce (
  func,
  wait = 0,
  {
    leading = false,
    cancelObj = 'canceled',
  } = {},
) {
  let timerId
  let latestResolve
  let shouldCancel

  const debounced = function ( ...args) {
    if (!latestResolve) { // The first call since last invocation.
      return new Promise((resolve, reject) => {
        latestResolve = resolve
        if (leading) {
          invokeAtLeading.apply(this, [args, resolve, reject])
        } else {
          timerId = setTimeout(invokeAtTrailing.bind(this, args, resolve, reject), wait)
        }
      })
    }

    shouldCancel = true
    return new Promise((resolve, reject) => {
      latestResolve = resolve
      timerId = setTimeout(invokeAtTrailing.bind(this, args, resolve, reject), wait)
    })
  }

  function invokeAtLeading ( args, resolve, reject) {
    func.apply(this, args).then(resolve).catch(reject)
    shouldCancel = false
  }

  function invokeAtTrailing ( args, resolve, reject) {
    if (shouldCancel && resolve !== latestResolve) {
      reject(cancelObj)
    } else {
      func.apply(this, args).then(resolve).catch(reject)
      shouldCancel = false
      clearTimeout(_nullishCoalesce(timerId, () => ( undefined)))
      timerId = latestResolve = null
    }
  }

  // The debounced wrapper resolves with whatever `func` resolves with, so it
  // has `func`'s signature; TypeScript cannot infer that through `apply`.
  return debounced 
}

exports. default = asyncDebounce
